import React, { useState, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";

import { AppContext } from "../../data/state";

import "./CreatePrintStatement.css";
import MyTitle from "../../components/MyTitle/MyTitle";
import server from "../../api/server";
import Loading from "../../components/Loading/Loading";
import MyModal from "../../components/MyModal/MyModal";
import MyDatePicker from "../../components/MyDatePicker/MyDatePicker";
import moment from "moment";

const CreatePrintStatement: React.FC = () => {
  const { state, dispatch } = useContext(AppContext);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [isLoading, setIsLoading] = useState(false);
  const [modalBody, setModalBody] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modal, setModal] = useState(false);

  const getPDFStatement = async () => {
    try {
      setIsLoading(true);
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${state.token}`,
      };
      const data = {
        StartDate: moment(startDate).format("YYYY-MM-DD"),
        EndDate: moment(endDate).format("YYYY-MM-DD"),
      };

      const request = await server.post(
        "/reports/company-statement",
        JSON.stringify(data),
        {
          headers,
          responseType: "blob"
        }
      );

      const response: string = request.data;


      const pdfBlob = new Blob([response], { type: 'application/pdf'});
      saveAs(pdfBlob,'Company_Statement.pdf');

      setIsLoading(false);

      setModalTitle(modalText[0].modalTitle);
      setModalBody(modalText[0].modalBody);
      setModal(true);
    } catch (error) {
      setModalTitle("Error!");
      setModalBody("There's an error on trying to generate the file");
      setModal(true);
      setIsLoading(false);
    }
  };


  const onChangeStartDate = (value) => {
    setStartDate(value);
  };

  const onChangeEndDate = (value) => {
    setEndDate(value);
  };

  const [today, setToday] = useState(new Date());

  const modalText = [
    {
      modalTitle: "PDF generated",
      modalBody: "PDF generated",
    },
  ];

  const onChangeModal = (value: any) => {
    setModal(value);
  };

  const onSubmitFormCompanyLocation = (e: any) => {
    e.preventDefault();
    getPDFStatement();
  };

  return (
    <>
      {isLoading && <Loading />}
      <MyModal
        modalTitle={modalTitle}
        modalBody={modalBody}
        modalValue={modal}
        onChangeModal={onChangeModal}
      />
      <MyTitle title="Print statement" />
      <section className="section-create">
        <div className="card-create">
          <div className="card-head-create">
            <h1 className="title-card-create">Print statement</h1>
          </div>
          <div className="card-body-create">
            <form
              action=""
              onSubmit={onSubmitFormCompanyLocation}
              className="form-container"
            >
              <div className="form-container-input">
                <span className="label-input-create">Start Date:</span>
                <MyDatePicker
                  setDatePicker={onChangeStartDate}
                  dateDefault={today}
                />
              </div>
              <div className="form-container-input">
                <span className="label-input-create">End Date:</span>
                <MyDatePicker
                  setDatePicker={onChangeEndDate}
                  dateDefault={today}
                />
              </div>
              <div className="btn-container-create">
                <button type="submit" className="btn-submit-create">
                  <span className="label-btn-submit">Submit</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default CreatePrintStatement;
